import React, { useCallback, useState } from 'react';
import axiosInstance from '@cp/utils/ApiHelper';
import { ErrorMessage } from '@cp/components/UploadComponent/UploadComponent';
import { GenericObject } from '@cp/src/types/CommonConstans';

export enum UPLOAD_STATUS {
  IDLE = 'IDLE',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

interface UseUploadParams {
  onFileUploadedSuccess?: (res?: GenericObject) => void;
  onFileUploadedError?: () => void;
}

function UseUpload({ onFileUploadedSuccess, onFileUploadedError }: UseUploadParams) {
  const [fileStatus, setFileStatus] = useState(UPLOAD_STATUS.IDLE);
  const [file, setFile] = useState(null as File | null);
  const [error, setError] = useState<ErrorMessage>({ message: '', fileName: null });

  const upload = useCallback(
    (file: File | null, uploadUrl: string, responseApi?: GenericObject) => {
      if (!file) {
        setError({ message: 'Please select a file', fileName: null });
        return;
      }
      setFileStatus(UPLOAD_STATUS.IN_PROGRESS);
      if (!file) {
        return;
      }
      return axiosInstance
        .put(uploadUrl, file)
        .then(_ => {
          setFileStatus(UPLOAD_STATUS.SUCCESS);
          onFileUploadedSuccess && onFileUploadedSuccess(responseApi);
        })
        .catch(_ => {
          setFileStatus(UPLOAD_STATUS.ERROR);
          onFileUploadedError && onFileUploadedError();
        });
    },
    [onFileUploadedSuccess, onFileUploadedError]
  );

  const resetFileStatus = useCallback(() => {
    setFileStatus(UPLOAD_STATUS.IDLE);
  }, []);

  return { fileStatus, upload, resetFileStatus, setFile, file, error, setError };
}

export default UseUpload;
